import { render, staticRenderFns } from "./TipoOcorrenciaList.vue?vue&type=template&id=244b52a0&scoped=true"
import script from "./TipoOcorrenciaList.vue?vue&type=script&lang=js"
export * from "./TipoOcorrenciaList.vue?vue&type=script&lang=js"
import style0 from "./TipoOcorrenciaList.vue?vue&type=style&index=0&id=244b52a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b52a0",
  null
  
)

export default component.exports